import FormFields from "pages/components/FormFields";
import Section from "pages/components/Section";

export default function PersonalInfos(props: any) {
  const { values, handleInputChange, options, formatErrorObject, errors, isCreate } =
    props;

  return (
    <Section title={"personal_infos"}>
      <FormFields.RadioGroup
        name="gender"
        value={values.gender}
        onChange={handleInputChange}
        items={options.gender}
        required
        {...formatErrorObject(errors.gender)}
      />

      <FormFields.Select
        name="language"
        value={values.language}
        onChange={handleInputChange}
        options={options.language}
        required
        sx={{ alignSelf: "end" }}
        {...formatErrorObject(errors.language)}
      />
      <FormFields.TextInput
        name="firstName"
        value={values.firstName}
        onChange={handleInputChange}
        required
        {...formatErrorObject(errors.firstName)}
      />

      <FormFields.TextInput
        name="lastName"
        value={values.lastName}
        onChange={handleInputChange}
        required
        {...formatErrorObject(errors.lastName)}
      />
      <FormFields.DatePicker
        name="birthDate"
        value={values.birthDate}
        onChange={handleInputChange}
        required
        {...formatErrorObject(errors.birthDate)}
      />

      <FormFields.TextInput
        name="profession"
        value={values.profession}
        onChange={handleInputChange}
        disabled={!isCreate}
        required
        {...formatErrorObject(errors.profession)}
      />
    </Section>
  );
}
